import {isStaticImage} from '../../common/util/isStaticImage';
import {isSticker} from '../../common/util/isSticker';

// NB: Used in inlineMathService
export const MEDIA_TYPE = Object.freeze({
    GIF: 'gif',
    MEME: 'meme',
    STICKER: 'sticker',
});

export function getMediaType(gif: api.Post): string {
    if (isStaticImage(gif)) {
        return MEDIA_TYPE.MEME;
    } else if (isSticker(gif)) {
        return MEDIA_TYPE.STICKER;
    } else {
        return MEDIA_TYPE.GIF;
    }
}
